// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
      	activeLoadPreviousPage: true, 
      	requestInstantly: true,
      	keepTabOpenState: true,
        filterTreeMobileStyle: 'style3'
	},
};

(function() {
	BoostPFS.inject(this);

  function getQuickAddToCartTable(data) {
    const { id, variants } = data

    const locales = variants[0].option1.split(',').reduce((locales, size) => {
      const maleSizeLabel = size.slice(0, 2)
      const femaleSizeLabel = size.slice(0, 3)

      if (['USW'].includes(femaleSizeLabel)) return [...locales, femaleSizeLabel] 
      if (['US', 'EU', 'UK'].includes(maleSizeLabel)) return [...locales, maleSizeLabel] 
      return locales
    }, [])

    const tabRadios = locales.length > 0 
      ? locales.map((locale, i) => `<input aria-hidden="true" class="qatc__tab-input qatc__tab-input--${i}" type="radio" id="size-switch--${locale}-${id}" name="size-switch--${id}" value="${locale}" ${locale === 'EU' ? 'checked' : ''}>`).join('')
      : ''
    
    const header = locales.length > 0 ? `<div class="qatc__tabs">
      ${locales.map((locale, i) => `
        <label class="qatc__tab-label qatc__tab-label--${i}" for="size-switch--${locale}-${id}">${locale}</label>
      `).join('')}
    </div>` : ''

    const body = locales.length > 0 ? `<div class="qatc__options ${variants.length > 15 ? 'qatc__options--condensed' : ''}">
        ${variants.map(variant => {
          
          return `
            <input class="qatc__size-input" aria-hidden="true" type="radio" name="id" value="${variant.id}" id="${variant.option1}-${id}" ${!variant.available ? 'disabled' : ''} />
            <label class="qatc__size-label" type="radio" for="${variant.option1}-${id}">
              ${locales.map((locale, i) => {
                return `<span class="qatc__size-translation qatc__size-translation--${i}">
                  ${variant.option1.split(",").filter(str => str.includes(locale))[0]?.replace(locale, '')}
                </span>`
              }).join('')}
            </label>`
        }).join('')
      }</div>` : `<div class="qatc__options ${variants.length > 15 ? 'qatc__options--condensed' : ''}">${variants.map(variant => {
        return `
          <input class="qatc__size-input" aria-hidden="true" type="radio" name="id" value="${variant.id}" id="${variant.option1}-${id}" ${!variant.available ? 'disabled' : ''} />
          <label class="qatc__size-label" type="radio" for="${variant.option1}-${id}">
            <span class="qatc__size-translation qatc__size-translation--one-size">
              ${variant.option1}
            </span>
          </label>`
      }).join('')}</div>`

    // const 
    return `
    <div class="qatc__content-wrapper">
      ${tabRadios}
      ${header}
      <div class="qatc__options-container">${body}</div>
    </div>`
  }

  function getQuickAddToCartHTML(data) {
    const isOneSize = data.options.every((option) => option === 'title')
    const unavailable = !data.tags.includes('Store exclusive') && (!data.available || ["Sold Out", "Coming Soon"].some(tag => data.tags.includes(tag)));

    return `
      <input class="qatc__visibility-input" aria-hidden="true" type="radio" name="qatc-toggle" id="qatc-toggle-${data.id}" /> 
      <form class="qatc" data-collection-quick-add-to-cart id="quick-add-to-cart-${data.id}">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="quantity" value="1">
        
        <div class="qatc__container">
          ${isOneSize ? `<input type="hidden" name="id" value="${data.variants[0].id}" />` : `<div class="qatc__content">${getQuickAddToCartTable(data)}</div>`}
          
          <div class="qatc__footer">
            ${isOneSize ? '' : '<input class="qatc__size-input--default" aria-hidden="true" type="radio" name="id" checked disabled />'}
            <button class="qatc__button js-go-cart-add-to-cart ${unavailable && 'qatc__button--sold-out'}" data-product-handle="${data?.handle}" type="submit" ${isOneSize && unavailable === false ? '' : 'disabled'}>
              <span class="qatc__button-text qatc__button-text--toggle">${unavailable ? window.theme.strings.pdpSoldOut : isOneSize ? window.theme.strings.addToCart : window.theme.strings.quickShop }</span>
              <span class="qatc__button-text qatc__button-text--submit">${window.theme.strings.addToCart}</span>
            </button>
            ${isOneSize || unavailable ? '' : `<label class="qatc__toggle" for="qatc-toggle-${data.id}" aria-hidden="true"></label>`}
          </div>
        </div>
      </form>`
  }

	
	ProductGridItem.prototype.compileTemplate = function(data) {
    if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.tags.includes('Store exclusive') && (!data.available || data.tags.includes('Sold Out')); // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    // totalQuantity used for "Few Left" tag
    const totalQuantityArray = data.variants.map(variant => variant.inventory_quantity);
    const totalQuantity = totalQuantityArray.reduce((total, value) => total += value);
    const noTrackedInventory = !soldOut && totalQuantity === 0; // If the product has no tracked quantity on Shopify and is never sells out
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {

			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-whole medium-up--one-whole';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-whole medium-up--one-whole';
				imageSize = '0x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-whole medium-up--one-whole';
				imageSize = '195x';
				break;
		}
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);
    
		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
        var thumbUrl = Utils.getFeaturedImage(images, '300x300');
        var thumbUrlData = Utils.getFeaturedImage(images, '{width}x');
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
    itemImagesHtml += '<div style="padding-top:';
    const mainImageClass = images.length === 1 ? 'main-image-only' : 'main-image';
		// if (images.length > 0) {
		// 	aspect_ratio = images[0]['width'] / images[0]['height'];
		// 	itemImagesHtml += 1 / aspect_ratio * 100;
		// } else {
		// 	itemImagesHtml += 100;
		// }
		itemImagesHtml += '120%;">';
    itemImagesHtml += data.tags.includes('Coming Soon') ? '' : getQuickAddToCartHTML(data);
		itemImagesHtml += '<img id="' + imgId + '" ' +
			`class="grid-view-item__image ${mainImageClass} lazyload" ` +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
      'alt="{{itemTitle}}">';
    if (data.images_info.length > 1) {
      itemImagesHtml += '<img ' +
			'class="grid-view-item__image hover-image lazyload" ' +
			'src="' + Utils.optimizeImage(data.images_info[1]['src'], '300x300') + '" ' +
			'data-src="' + Utils.optimizeImage(data.images_info[1]['src'], '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
        }
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add data json
		itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));
      	var itemLabels = '';
      	if (data.tags) {
          itemLabels += '<div class="boost-pfs-filter-product-item-label">';
          if (data.tags.includes('Store exclusive')) {
            itemLabels += `<span class="store-exclusive boost-pfs-filter-label">${window.theme.strings.storeExclusiveTag}</span>`;
          } else if (data.tags.includes('Coming Soon')) {
            itemLabels += `<span class="coming-soon boost-pfs-filter-label">${window.theme.strings.comingSoon}</span>`;
          } else if (soldOut) {
            itemLabels += `<span class="soldout boost-pfs-filter-label">${window.theme.strings.soldOut}</span>`;
          } else if (totalQuantity <= 10 && !noTrackedInventory) {
            itemLabels += `<span class="fewleft boost-pfs-filter-label">${window.theme.strings.fewLeft}</span>`;
          } else if (totalQuantity == 1) {
            itemLabels += `<span class="fewleft boost-pfs-filter-label">${window.theme.strings.oneLeft}</span>`;
          } else if (data.tags.includes('New Arrivals')) {
            itemLabels += `<span class="new boost-pfs-filter-label">${window.theme.strings.newArrivals}</span>`;
          } else if (onSale) {
            itemLabels += `<span class="sale boost-pfs-filter-label">${window.theme.strings.sale}</span>`;
          }
          
          itemLabels += '</div>'
        }      	
      	itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabels);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available || data.tags.includes('Sold Out'); // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
	
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
	
		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	
		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
	
		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
	
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	
		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 1024px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 1024 * aspect_ratio;
				} else {
					if (image.width < 1024) {
						maximum_width = image.width;
					} else {
						maximum_width = 1024;
					}
				}
				imageStyle += '@media screen and (max-width: 1023px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
	
		priceHtml += '<dl class="price' + onSaleClass + '" data-price><span>';
		if (boostPFSConfig.custom.vendor_enable) {
			priceHtml += '<div class="price__vendor">';
			priceHtml += '<dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt>';
			priceHtml += '<dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd>';
			priceHtml += '</div>';
		}
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
      
      
		if (data.available || data.tags.includes("Store exclusive")) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else if (data.available || data.tags.includes("Coming Soon"))  {
			priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		} else {
			priceHtml += boostPFSConfig.label.sold_out;
		}
      
      
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</span></dl>';
	
		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
	
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
	
		if (Settings.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = boostPFSTemplate.paginateHtml;
	
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
	
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
	
			// Build page items
			var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);
	
			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += `<button name="${sortingArr[k]}" value="${k}" class="boost-pfs-filter-button sortby__option">
					<span class="boost-pfs-check-box"></span>
					<span id="${k}" class="boost-pfs-filter-option-value sortby__option-label">${sortingArr[k]}</span>
					<span class="boost-pfs-filter-option-amount"></span></button>`;
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};
  
  // Build Sorting event
	  ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-top-sorting .boost-pfs-filter-option-item-list-multiple-list .boost-pfs-filter-button').on('click', function(e){
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).attr('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});		
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
    const initialProducts = document.querySelectorAll('.grid__item');
    initialProducts.forEach(product => {
      product.dataset.eventListenerAdded = "true"
      product.addEventListener('click', () => {
        window.dataLayer.push({
          "event": "ap_product_click",
          "path": window.location.pathname,
          "type": "collection_page",
          "products": [
            {
              "name": product.dataset.productTitle.replace("'", ''),
              "id": product.dataset.id.toString()
            }
          ]
        });
      })
    })

    Filter.prototype.afterRender = function() {
      // handle GTM event - size filter button click
      Array.from(document.querySelectorAll('#boost-pfs-filter-tree-pf-t-size .boost-pfs-filter-option-item-list .boost-pfs-filter-button')).filter(button => button.dataset.eventListenerAdded !== "true").forEach(sizeFilter => {
        sizeFilter.dataset.eventListenerAdded = "true"
        sizeFilter.addEventListener('click', () => {
          const value = sizeFilter.querySelector('.boost-pfs-filter-option-value').innerHTML
          if (!sizeFilter.parentNode.classList.contains('selected')) {
            window.dataLayer.push({
              "event": "ap_apply_size_filter",
              "value": value
            });
          }
        })
      })
      // handle GTM event - brand filter button click
      Array.from(document.querySelectorAll('#boost-pfs-filter-tree-pf-v-brand .boost-pfs-filter-option-item-list .boost-pfs-filter-button')).filter(button => button.dataset.eventListenerAdded !== "true").forEach(brandFilter => {
        brandFilter.dataset.eventListenerAdded = "true"
        brandFilter.addEventListener('click', () => {
          const value = brandFilter.querySelector('.boost-pfs-filter-option-value').innerHTML
          if (!brandFilter.parentNode.classList.contains('selected')) {
            window.dataLayer.push({
              "event": "ap_apply_brand_filter",
              "value": value
            });
          }
        })
      })
      Array.from(document.querySelectorAll('.sortby__option-list .sortby__option')).filter(button => button.dataset.eventListenerAdded !== "true").forEach(sortButton => {
        sortButton.dataset.eventListenerAdded = "true"
        sortButton.addEventListener('click', () => {
          const value = sortButton.querySelector('.boost-pfs-filter-option-value').innerHTML
          if (!sortButton.querySelector('.boost-pfs-filter-option-value').classList.contains('sortby__option--selected')) {
            window.dataLayer.push({
              "event": "ap_use_sort_function",
              "value": value
            });
          }
        })
      })
    }

		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
      
        setTimeout(function() {
        	buildSizeSelect();          
            buildMobileSort()
          
            var changedButton = false;

            if (Globals.hasFilterOptionParam) {
              var numberFilters = 0;

              for (var i of Object.keys(Globals.queryParams)) {            
                if (i.indexOf('pf_') === 0) numberFilters += Globals.queryParams[i].length;
              }

              if (numberFilters > 0) {
                changedButton = true;
                jQ('.boost-pfs-filter-tree-mobile-button button').html(numberFilters + ' Filter' + (numberFilters > 1 ? 's' : ''));
              }
            }

            if (!changedButton) jQ('.boost-pfs-filter-tree-mobile-button button').html(Labels.refineMobile);          
        }, 400);   
	};
  
    FilterOptionItemBox.prototype.afterRender = function() {
      if (this.label.indexOf(':') > -1) {
        var array = this.label.split(':');
        this.$element.addClass(array[0].toLowerCase());
        this.$element.find('.boost-pfs-filter-option-value').html(array[1].toUpperCase());
      }
    }   
    
    
    function buildSizeSelect() {
      var html = '<div class="boost-size-select">';
      html += `<a href="#" ${window.isFootwear ? 'class="active"' : ''}>EU</a>`;
      html += '<a href="#">US</a>';
      html += '<a href="#">USW</a>';
      html += '<a href="#">UK</a>';
      html += '<a href="#">Kids</a>'; 
      html += `<a href="#" ${!window.isFootwear ? 'class="active"' : ''}>Apparel</a>`;
      html += '</div>';

      if (jQ('.boost-pfs-filter-option-size .boost-size-select').length === 0) {
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-content-inner').prepend(html);

        jQ('.boost-pfs-filter-option-size .boost-size-select a').each(function(index, item){
          var val = jQ(item).html().toLowerCase()
          if(!jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-label.' + val).length) jQ(item).hide()
        })

        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-label').hide()
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-content-inner').addClass('is-active-' + (window.isFootwear ? 'eu' : 'apparel'))
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-label.' + (window.isFootwear ? 'eu' : 'apparel') ).show()
      }     
      
      jQ('.boost-size-select a').off('click').on('click', function(e) {
        e.preventDefault();
        
        if (Globals.queryParams.hasOwnProperty('pf_t_size')) jQ('.boost-pfs-filter-option-size .boost-pfs-filter-clear').trigger('click');
        
        var val = jQ(this).html();
        
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-content-inner').removeClass('is-active-eu is-active-uk is-active-us is-active-apparel is-active-usw is-active-kids').addClass('is-active-' + val.toLowerCase());                
        jQ('.boost-size-select a').removeClass('active');
        jQ(this).addClass('active');
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-label').hide()
        jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-label.' + val.toLowerCase()).show()
        
        
//         jQ(this).parents('.boost-pfs-filter-option-content').find('.boost-pfs-filter-clear').trigger('click');
        
//         jQ(this).parents('.boost-pfs-filter-option').find('.boost-pfs-filter-option-title-heading').trigger('click');
      });
    }
  
  	var originalApplyFilter = FilterApi.applyFilter;
	FilterApi.applyFilter = function (eventType, eventInfo) {
		if (eventType == 'clear') {
			eventType = 'clear-custom';
		}
		originalApplyFilter.call(this, eventType, eventInfo);
	} 
    
    /* start-boost-52454 */  
    function buildMobileSort() {      
      if (!Utils.isMobile() || jQ('.boost-pfs-filter-mobile-sorting').length > 0) return;
      
      var html = '';
      
      var sortingHtml = `
		<div class="boost-pfs-filter-option-collapsed boost-pfs-filter-option boost-pfs-filter-option-box boost-pfs-filter-option-sort boost-pfs-filter-no-scrollbar boost-pfs-filter-option-column-1 boost-pfs-filter-mobile-sorting">
          <div class="boost-pfs-filter-option-title" style="">
            <button aria-label="Filter by Size" tabindex="0" class="boost-pfs-filter-button boost-pfs-filter-option-title-heading" aria-expanded="false">
              <span class="boost-pfs-filter-option-title-text">${boostPFSConfig.label.sorting}</span>
            </button>
            <div class="boost-pfs-filter-option-content" style="display: none;">        				
              <div class="boost-pfs-filter-option-content-inner">        					
                  <ul class="boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-single-list">{{sortingItems}}</ul>
              </div>
          </div>
		</div>
       </div>
	  `;
	  
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        var paramSort = Globals.queryParams.sort || '';
        var activeClass = '';
        
        for (var k in sortingArr) {
          activeClass = '';
		  if(paramSort == k) {
		  	activeClass = 'selected';
		  }
          
          sortingItemsHtml += `<li class="boost-pfs-filter-option-item boost-pfs-filter-option-label ${activeClass}">
					<button role="button" class="boost-pfs-filter-button" data-value="${k}">						
						<span class="boost-pfs-filter-option-value">${sortingArr[k]}</span>						
					</button>
				</li>`;
        }
        html = sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
      
      // jQ(html).insertBefore('.boost-pfs-filter-tree-v .boost-pfs-filter-options-wrapper');
      jQ(".boost-pfs-filter-tree-v .boost-pfs-filter-options-wrapper").append(
        html
      );
      bindSortEvent();      
    }
  
    function bindSortEvent() {      
      
      
      jQ('.boost-pfs-filter-mobile-sorting .boost-pfs-filter-option-title > button').off('click').on('click', function() {
        var $sortDiv = jQ(this).parents('.boost-pfs-filter-mobile-sorting');
        $sortDiv.toggleClass('boost-pfs-filter-option-collapsed');
        $sortDiv.find('.boost-pfs-filter-option-content').toggle();
      });
      
      jQ('.boost-pfs-filter-mobile-sorting .boost-pfs-filter-option-content button').off('click').on('click', function(e) {        
        e.preventDefault(); 
        
        jQ('.boost-pfs-filter-tree-v .boost-pfs-filter-mobile-sorting .boost-pfs-filter-option-item').removeClass('selected');
        jQ(this).parents('.boost-pfs-filter-option-item').addClass('selected');
        
        FilterApi.setParam('sort', jQ(this).data('value'));
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('sort');
      });
	  
    }
  
  	// Hide sort on desktop when clicking outsite
    jQ(document).on('click', function(e) {      
      var container = jQ('.boost-pfs-filter-top-sorting');
      
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
          container.find('.boost-pfs-filter-option-content-inner').removeClass('sortby__option-list--open');
          container.find('.boost-pfs__arrow-sorting').removeClass('open');        
      }
    });
    /* end-boost-52454 */
})();